import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=420e411b&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=420e411b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e411b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420e411b')) {
      api.createRecord('420e411b', component.options)
    } else {
      api.reload('420e411b', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=420e411b&scoped=true", function () {
      api.rerender('420e411b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Title.vue"
export default component.exports